import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Button, Modal } from 'semantic-ui-react'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { getFormValues, Field, SubmissionError } from 'redux-form'
import { IconButton, Collapse, Fade, Card, CardHeader, CardContent } from '@material-ui/core'
import { ProcurementBody } from '../../../styled'

import { showModal, showConfirmModal } from 'ducks/app'
import { getGlAccount } from 'ducks/purchaseRequisition'
import { getHrmsMembers, addOtherMember, getAllMembers } from 'ducks/member'
import { getOptionTitle } from '../../helper'
import { getVendors, getPrSpecialOptions, getPoNumber } from 'ducks/options'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { BudgetDetailContainer, RequestInformationContainer, GeneralInfoContainer } from './styled'
import { getMappingCompanyPlants, getMappingPlantStorageLocations } from 'ducks/mappingData'
import { getGoaByCompany, getGoaItem, getProjectByCompany, getSpecialApproval, addOtherProject } from 'ducks/goa'
import { purchaseOrderDetailPath } from 'routes'
import { AdditionalRemark } from '../../AttributeData'
import * as v from 'variables/styles'
// import r from 'reactotron-react-js'

const GeneralDetail = (props) => {
  const {
    valueForm, change, menus,
    members, memberLoading, addOtherMember,
    companyOptions, vendorOptions, vendorLoading,
    subCategory, mappingPurchasingGroups,
    projectOptions, projectLoading, addOtherProject,
    specialApprovalOptions, onSubmit, showConfirmModal, isDetail = false
  } = props

  const [showReqInfo, setShowReqInfo] = useState(true)
  const [showGeneralInfo, setShowGeneralInfo] = useState(true)
  const [modal, showModal] = useState({ show: false, header: '', message: '' })

  useEffect(() => {
    if (!props.prSpecial.data.length && !props.prSpecial.loading) {
      props.getPrSpecialOptions()
    }

    props.getAllMembers(isDetail,(membersData) => {
      if (valueForm.requesterUser) {
        var member = membersData.find(m => m.username.toLowerCase() === valueForm.requesterUser.toLowerCase())
        if (member) {
          change('costCenterByRequester', `${parseInt(member.costCenterCode) || ''}`)
        }
      }
    })

    // props.getHrmsMembers(isDetail,(membersData) => {
    //   if (valueForm.requesterUser) {
    //     var member = membersData.find(m => m.username.toLowerCase() === valueForm.requesterUser.toLowerCase())
    //     if (member) {
    //       change('costCenterByRequester', `${parseInt(member.costCenterCode) || ''}`)
    //     }
    //   }
    // })
  }, [])

  useEffect(() => {
    if (valueForm.special || valueForm.isAffiliatedCompanies || valueForm.isPartnersPreQualified) {
      if (vendorOptions.length === 0 && !vendorLoading) {
        props.getVendors()
      }
    }
  }, [valueForm.special, valueForm.isAffiliatedCompanies, valueForm.isPartnersPreQualified])

  useEffect(() => {
    if (valueForm.companyCode) {
      if (props.goa[valueForm.companyCode] === undefined) {
        if (valueForm.companyCode !== props.goaCompanyLoading) {
          props.getGoaByCompany(valueForm.companyCode)
        }
      }

      if (props.projects[valueForm.companyCode] === undefined) {
        if (valueForm.companyCode !== props.projectCompanyLoading) {
          props.getProjectByCompany(valueForm.companyCode)
        }
      }

      if (props.poNumbers.companyCode !== valueForm.companyCode) {
        props.getPoNumber(valueForm.companyCode)
      }
    }
  }, [valueForm.companyCode])

  useEffect(() => {
    if (valueForm.goaId) {
      if (props.goaItems[valueForm.goaId] === undefined) {
        if (valueForm.goaId !== props.goaItemByGoaIdLoading) {
          props.getGoaItem(valueForm.goaId, 'PurchaseRequisition')
        }
      }
    }
  }, [valueForm.goaId])

  useEffect(() => {
    if (valueForm.projectId) {
      if (props.specialApprovals[valueForm.projectId] === undefined) {
        if (valueForm.projectId !== props.specialApprovalProjectIdLoading) {
          props.getSpecialApproval(valueForm.projectId)
        }
      }
    }
  }, [valueForm.projectId])

  useEffect(()=>{
    if(valueForm.special){
      props.getPrSpecialOptions('Special')
    }else if(valueForm.isAffiliatedCompanies){
      props.getPrSpecialOptions('AffiliatedCompanies')
    }else if (valueForm.isPartnersPreQualified){
      props.getPrSpecialOptions('PartnersPreQualified')
    }
  },[valueForm.special, valueForm.isAffiliatedCompanies, valueForm.isPartnersPreQualified])

  const memberOptions = members.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))

  const onSelectRequester = (value) => {
    if (value) {
      var member = members.find(m => m.username.toLowerCase() === value.toLowerCase())
      if (member) {
        if (valueForm.status !== 5) {
          change('companyCode', member.companyCode)
          change('projectId', '')
          change('specialApprovalId', '')
        }
        change('costCenterByRequester', `${parseInt(member.costCenterCode) || ''}`)
        change('requesterDepartment', member.mainDepartmentEn)
      } else {
        if (valueForm.status !== 5) {
          change('companyCode', '')
          change('projectId', '')
          change('specialApprovalId', '')
        }
        change('costCenterByRequester', '')
        change('requesterDepartment', '')
      }
    }
  }

  const beforeRequesterChange = (valueForm) => (props) => {
    if (valueForm.requesterUser && valueForm.requesterUser !== props.value) {
      if (valueForm.items && valueForm.items.length) {
        props.onChange()
        let newRequester = members.find(m => m.username.toLowerCase() === props.value.toLowerCase())
        let currentRequester = companyOptions.find(m => m.value === valueForm.companyCode)
        if (newRequester.companyCode !== valueForm.companyCode) {
          showConfirmModal(
            true,
            {
              header: `The requester's company has difference from current company.`,
              message:
                <React.Fragment>
                  {`Do you want to change company(${currentRequester.text.replace(`${valueForm.companyCode} : `, '')}) to requester's company(${newRequester.companyEn})?`}
                  <br />
                  If you click " <b>Yes</b> "  the item details will delete immediately or " <b>No</b> " not change company.
                </React.Fragment>,
              btnConfirmText: 'Yes',
              onClickConfirm: () => {
                if (props.specialOnChange) props.specialOnChange()
                change('items', [])
                change('budgetData', { costCenter: [], wbs: [], internalOrder: [] })
                change('totalAmount', 0)
                change('vatAmount', 0)
                change('totalAmountIncludeVat', 0)
              },
              btnCancelText: 'No',
            }
          )
        } else {
          let warnItems = valueForm.items.filter(i => i.accountAssignment === 'A' || i.accountAssignment === 'K' || i.accountAssignment === 'Z')
          const uniqueCostCenter = []
          warnItems.forEach(i => {
            if (uniqueCostCenter.indexOf(i.costCenter) === -1) {
              uniqueCostCenter.push(i.costCenter)
            }
          })

          let differenceCostCenter = uniqueCostCenter.filter(c => c !== newRequester.costCenterCode)

          if (differenceCostCenter.length > 0) {
            showConfirmModal(
              true,
              {
                header: `The requester's cost center has difference from current cost center.`,
                message:
                  <React.Fragment>
                    {`Do you want to change cost center to ${newRequester.costCenterCode}?`}
                    <br />
                    If you click " <b>Yes</b> "  the item details will delete immediately or " <b>No</b> " not to change cost center.
                  </React.Fragment>,
                btnConfirmText: 'Yes',
                onClickConfirm: () => {
                  if (props.specialOnChange) props.specialOnChange()
                  change('items', [])
                  change('budgetData', { costCenter: [], wbs: [], internalOrder: [] })
                  change('totalAmount', 0)
                  change('vatAmount', 0)
                  change('totalAmountIncludeVat', 0)
                },
                btnCancelText: 'No',
              }
            )
          } else {
            props.onChange()
            if (props.specialOnChange) props.specialOnChange()
          }
        }
      } else {
        props.onChange()
        if (props.specialOnChange) props.specialOnChange()
      }
    } else {
      props.onChange()
      if (props.specialOnChange) props.specialOnChange()
    }
  }

  const beforeCompanyChange = (valueForm) => (props) => {
    if (valueForm.items && valueForm.items.length) {
      if (valueForm.companyCode && valueForm.companyCode !== props.value) {
        showConfirmModal(
          true,
          {
            header: `The item details will delete immediately`,
            message:
              <React.Fragment>
                {`Are you sure you want to ${props.value ? 'chenge' : 'clear'} company `}
                {props.value ?
                  <React.Fragment><b>{getOptionTitle(companyOptions, valueForm.companyCode, false)}</b> to <b>{getOptionTitle(companyOptions, props.value, false)}</b></React.Fragment>
                  : null
                }
              </React.Fragment>,
            btnConfirmText: 'Yes',
            onClickConfirm: () => {
              props.onChange()
              if (props.specialOnChange) props.specialOnChange()
              change('items', [])
              change('budgetData', { costCenter: [], wbs: [], internalOrder: [] })
              change('totalAmount', 0)
              change('vatAmount', 0)
              change('totalAmountIncludeVat', 0)
            },
            btnCancelText: 'No',
            onClickCancel: () => {
              props.clearSearchText()
            }
          }
        )
      } else {
        props.onChange()
        if (props.specialOnChange) props.specialOnChange()
      }
    } else {
      props.onChange()
      if (props.specialOnChange) props.specialOnChange()
    }
  }

  const onSubmitForm = (value) => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(10).then(() => {
      var { companyCode } = valueForm

      var defaultPurchasingGroup = ''
      var purchasingGroupByCompany = mappingPurchasingGroups.find(m => m.companyCode === valueForm.companyCode)
      if (subCategory.purchasingGroup) {
        if (subCategory.purchasingGroup[companyCode]) {
          if (subCategory.purchasingGroup[companyCode].length === 1) {
            defaultPurchasingGroup = subCategory.purchasingGroup[companyCode][0]
          } else {
            if (purchasingGroupByCompany) {
              subCategory.purchasingGroup[companyCode].forEach(p => {
                var match = purchasingGroupByCompany.purchasingGroups.find(pg => pg === p)
                if (match) {
                  defaultPurchasingGroup = match
                }
              })
            }
          }
        } else {
          if (subCategory.purchasingGroup.all) {
            if (subCategory.purchasingGroup.all.length === 1) {
              defaultPurchasingGroup = subCategory.purchasingGroup.all[0]
            } else {
              if (purchasingGroupByCompany) {
                subCategory.purchasingGroup.all.forEach(p => {
                  var match = purchasingGroupByCompany.purchasingGroups.find(pg => pg === p)
                  if (match) {
                    defaultPurchasingGroup = match
                  }
                })
              }
            }
          }
        }
      }

      if (defaultPurchasingGroup) {
        onSubmit(value)
      } else {
        showModal(true, 'Error', `Can't create purchase requisition category under company ${companyCode} \r\n
          (Because : Purchasing Group not support, Please contact admin.)`)
        throw new SubmissionError('error.validationErrors')
      }
    })
  }

  const getSpecialReasonOption = (specialReason) => {
    return props.prSpecial.data.find(x => x.value === (specialReason || valueForm.specialReason || ''))
  }

  const getVendorOptions = (specialReason, subReason) => {
    var reason = getSpecialReasonOption(specialReason)
    var vendorCondition = null
    if (reason) {
      if ((subReason || valueForm.subSpecialReason)) {
        var subReasonOpt = (reason.subOptions || []).find(x => x.value === ((subReason || valueForm.subSpecialReason)))
        if (subReasonOpt) {
          vendorCondition = subReasonOpt.vendorCondition
        }
      } else {
        vendorCondition = reason.vendorCondition
      }
    }

    if (vendorCondition) {
      const { checkCase, positiveCheck, condition, vendorCodes } = vendorCondition
      if (checkCase === 'specific') {
        return vendorOptions.filter(v => (vendorCodes || []).includes(v.value)) || []
      } else if (checkCase === 'startsWith') {
        var conditions = condition.split('|') || []
        var vendorOpts = []

        conditions.forEach((c) => {
          vendorOpts = [
            ...vendorOpts,
            ...(vendorOptions.filter(v => v.value.startsWith(c) === positiveCheck) || [])
          ]
        })

        return vendorOpts
      }
    }

    return vendorOptions
  }

  const getVendorOptionsNonSpecial = (reason) => {
    var reasonItem = getSpecialReasonOption(reason)
    var vendorCondition = null
    if(reasonItem){
      var vendorCondition = reasonItem.vendorCondition
    }

    // r.log({ reason, vendorCondition })

    if (vendorCondition) {
      const { checkCase, positiveCheck, condition, vendorCodes } = vendorCondition
      if (checkCase === 'specific') {
        return vendorOptions.filter(v => (vendorCodes || []).includes(v.value)) || []
      } else if (checkCase === 'startsWith') {
        var conditions = condition.split('|') || []
        var vendorOpts = []

        conditions.forEach((c) => {
          vendorOpts = [
            ...vendorOpts,
            ...(vendorOptions.filter(v => v.value.startsWith(c) === positiveCheck) || [])
          ]
        })

        return vendorOpts
      }
    }
    
    return vendorOptions
  }

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <BudgetDetailContainer>
          <Card>
            <CardHeader
              title='Request Information'
              action={
                <IconButton aria-label='Expand' onClick={() => setShowReqInfo(!showReqInfo)}>
                  {showReqInfo ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              }
            />
            <Collapse in={showReqInfo}>
              <CardContent>
                <RequestInformationContainer>
                  <div className='rowFields'>
                    <Field name='title' label='Title (Request for)' require type={type.text} component={FieldInput} maxLength={200} maxLengthMessage='Title must be less than or equal to 200 characters' />
                  </div>
                  <div className='rowFields'>
                    <Field name='remark' label='Remark' type={type.textArea} component={FieldInput} />
                  </div>
                  <div className='rowFields'>
                    <Field
                      name='requesterUser'
                      label='Requester'
                      require
                      allowAdditions={false}
                      loading={memberLoading}
                      options={memberOptions}
                      onAddNewItem={addOtherMember}
                      type={type.select}
                      beforeOnChange={valueForm.status !== 5 ? beforeRequesterChange(valueForm) : null}
                      specialOnChange={onSelectRequester}
                      component={FieldInput} />
                    <Field
                      name='companyCode'
                      label='Company'
                      require
                      type={type.select}
                      specialOnChange={(value) => {
                        change('specialApprovalId', '')
                        change('projectId', '')
                        let member = members.find(m => lower(m.username) === valueForm.requesterUser)
                        if (member) {
                          if (member.companyCode !== value) {
                            change('costCenterByRequester', '')
                          }
                        }
                        // r.log({subCategory, menus, valueForm})
                        var category = menus.find(x => x.code === valueForm.menuCategory)
                        if (category && valueForm.items[0]) {
                          var subCat = category.subCategories.find(x => x.code === valueForm.items[0].menuSubCategory)
                          if (subCat) {
                            if (subCat.goaItemCode === undefined || subCat.goaItemCode === null || subCat.goaItemCode === '') {
                              if (subCat.goaItemCodes[value]) {
                                change('goaItemCode', subCat.goaItemCodes[value])
                              } else if (subCat.goaItemCodes['all']) {
                                change('goaItemCode', subCat.goaItemCodes['all'])
                              }
                            }

                            if (subCat.prType === undefined || subCat.prType === null || subCat.prType === '') {
                              if (subCat.prTypes[value]) {
                                change('type', subCat.prTypes[value])
                              } else if (subCat.prTypes['all']) {
                                change('type', subCat.prTypes['all'])
                              }
                            }
                          }
                        }

                        if (valueForm.isAdditional) {
                          if (props.poNumbers.companyCode !== value) {
                            props.getPoNumber(value, () => { change('referencePoNo', '') })
                          } else {
                            if (props.poNumbers.data.length === 0 && props.poNumbers.loading === false) {
                              props.getPoNumber(value, () => { change('referencePoNo', '') })
                            }
                          }
                        }
                      }}
                      options={companyOptions}
                      beforeOnChange={valueForm.status !== 5 ? beforeCompanyChange(valueForm) : null}
                      editable={valueForm.status !== 5 ? true : false}
                      component={FieldInput} />
                  </div>
                  <div className='rowFields'>
                    <Field
                      name='projectId'
                      label='Project Name'
                      allowAdditions
                      loading={projectLoading}
                      options={projectOptions}
                      type={type.select}
                      onAddNewItem={addOtherProject}
                      specialOnChange={() => change('specialApprovalId', '')}
                      component={FieldInput} />
                    {specialApprovalOptions.length ?
                      <Field name='specialApprovalId' label='Special Approval' options={specialApprovalOptions} type={type.select} component={FieldInput} /> :
                      <div style={{ flex: 1, marginRight: '1rem' }} />
                    }
                  </div>
                  <div className='rowFields'>
                    <Field name='requesterDepartment' editable={false} label='Department' type={type.text} component={FieldInput} />
                    <Field name='documentDate' label='Document Date' type={type.date} require component={FieldInput} />
                  </div>
                </RequestInformationContainer>
              </CardContent>
            </Collapse>
          </Card>
          <Card style={{ marginTop: '10px' }}>
            <CardHeader
              title='Type of Procurement '
              action={
                <IconButton aria-label='Expand' onClick={() => setShowGeneralInfo(!showGeneralInfo)}>
                  {showReqInfo ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              }
            />
            <Collapse in={showGeneralInfo}>
              <CardContent>
                <GeneralInfoContainer>
                  <div className='rowFields'>
                    <Field
                      name='priority'
                      label='Priority'
                      className='halfRow'
                      options={[
                        { title: 'Normal', value: 'normal', color: 'blue' },
                        { title: 'Urgent', value: 'urgent', color: 'red' },
                      ]}
                      type={type.tabSelection}
                      component={FieldInput} />
                  </div>
                  <div className='rowFields'>
                    <Field
                      name='special'
                      label='Special PR'
                      type={type.switch}
                      specialOnChange={(value) => {
                        if (value === true) {
                          change('isAdditional', false)
                          change('additionalReason', '')
                          change('referencePoNo', '')
                          change('referenceContractNo', '')
                        } else {
                          change('specialReason', '')
                          change('subSpecialReason', '')
                          change('vendorCode', '')
                        }
                      }}
                      component={FieldInput} />
                  </div>
                  <Collapse in={valueForm && valueForm.special} timeout={500}>
                    {
                      ((valueForm.specialReason || '').startsWith('SP') &&
                       (valueForm.specialReason || '').length === 4) ||
                      (valueForm.status || 0) === 0 ||
                      (valueForm.specialTitle || '') === '' ?
                        <React.Fragment>
                          <div className='rowFields'>
                            <Field
                              require
                              name='specialReason'
                              label='Reason'
                              type={type.radio}
                              options={props.prSpecial.data}
                              specialOnChange={(value) => {
                                change('subSpecialReason', '')
                                var vOpt = getVendorOptions(value, '')
                                if (vOpt.find(x => x.value === valueForm.vendorCode) === null) {
                                  change('vendorCode', '')
                                }
                              }}
                              component={FieldInput}
                            />
                          </div>
                          {
                            valueForm.specialReason === 'SP04' ?
                              <div className='rowFields'>
                                <Field
                                  require
                                  name='subSpecialReason'
                                  // label='Reason' 
                                  type={type.select}
                                  options={(getSpecialReasonOption() || {}).subOptions || []}
                                  specialOnChange={(value) => {
                                    var vOpt = getVendorOptions(valueForm.specialReason, value)
                                    if (vOpt.find(x => x.value === valueForm.vendorCode) === null) {
                                      change('vendorCode', '')
                                    }
                                  }}
                                  placeHolder='กรุณาเลือก'
                                  component={FieldInput}
                                />
                              </div> : null
                          }
                          <div className='rowFields'>
                            <Field
                              require
                              name='vendorCode'
                              label='Vendor'
                              options={getVendorOptions()}
                              loading={vendorLoading}
                              editable
                              placeHolder='กรุณาระบุชื่อ Vendor ที่ต้องการจัดจ้างพิเศษ'
                              type={type.select}
                              component={FieldInput}
                            />
                          </div>
                        </React.Fragment> :
                        <React.Fragment>
                          <div className='rowFields'>
                            <Field name='specialTitle' require label='Special PR Title' type={type.text} component={FieldInput} />
                          </div>
                          <div className='rowFields'>
                            <Field name='specialReason' require label='Special PR Reason' type={type.textArea} component={FieldInput} />
                          </div>
                          <div className='rowFields'>
                            <Field name='vendorCode' label='Vendor' options={vendorOptions} loading={vendorLoading} editable type={type.select} component={FieldInput} />
                          </div>
                        </React.Fragment>
                    }
                  </Collapse>
                  <div className='rowFields'>
                      <Field 
                        name='isAffiliatedCompanies' 
                        label='Affiliated Companies' 
                        type={type.switch}
                        specialOnChange={(value) => {
                          if (value === true) {
                            // clear Additional
                            change('isAdditional', false)
                            change('additionalReason', '')
                            change('referencePoNo', '')
                            change('referenceContractNo', '')
                            // clear special
                            change('special', '')
                            change('specialReason', '')
                            change('subSpecialReason', '')
                            //clear PartnersPreQualified
                            change('isPartnersPreQualified', '')
                            change('partnersPreQualifiedReason', '')
                            change('vendorCode', '')
                          } else {
                            // clear my self
                            change('isAffiliatedCompanies', '')
                            change('affiliatedCompaniesReason', '')
                            change('vendorCode', '')
                          }
                        }} 
                        component={FieldInput} />
                    </div>
                    <Collapse in={valueForm && valueForm.isAffiliatedCompanies} timeout={500}>
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='affiliatedCompaniesReason' 
                          label='Reason' 
                          type={type.radio}
                          options={props.prSpecial.data} 
                          specialOnChange={(value) => {
                            var vOpt = getVendorOptionsNonSpecial(value)
                            if (vOpt.find(x => x.value === valueForm.vendorCode) === null) {
                              change('vendorCode', '')
                            }
                          }}
                          component={FieldInput} 
                        />
                      </div>
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='vendorCode' 
                          label='Vendor' 
                          options={getVendorOptionsNonSpecial(valueForm.affiliatedCompaniesReason)} 
                          loading={vendorLoading} 
                          editable 
                          placeHolder='กรุณาระบุชื่อ Vendor ที่ต้องการจัดจ้างพิเศษ' 
                          type={type.select} 
                          component={FieldInput} 
                        />
                      </div>
                    </Collapse>
                    <div className='rowFields'>
                      <Field 
                        name='isPartnersPreQualified' 
                        label='Partners(Pre-Qualified)' 
                        type={type.switch}
                        specialOnChange={(value) => {
                          if (value === true) {
                            // clear Additional
                            change('isAdditional', false)
                            change('additionalReason', '')
                            change('referencePoNo', '')
                            change('referenceContractNo', '')
                            // clear special
                            change('special', '')
                            change('specialReason', '')
                            change('subSpecialReason', '')
                            //clear Affiliated
                            change('isAffiliatedCompanies', '')
                            change('affiliatedCompaniesReason', '')
                            change('vendorCode', '')
                          } else {
                            // clear my self
                            change('isPartnersPreQualified', '')
                            change('partnersPreQualifiedReason', '')
                            change('vendorCode', '')
                          }
                        }} 
                        component={FieldInput} />
                    </div>
                    <Collapse in={valueForm && valueForm.isPartnersPreQualified} timeout={500}>
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='partnersPreQualifiedReason' 
                          label='Reason' 
                          type={type.radio}
                          options={props.prSpecial.data} 
                          specialOnChange={(value) => {
                            var vOpt = getVendorOptionsNonSpecial(value)
                            if (vOpt.find(x => x.value === valueForm.vendorCode) === null) {
                              change('vendorCode', '')
                            }
                          }}
                          component={FieldInput} 
                        />
                      </div>
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='vendorCode' 
                          label='Vendor' 
                          options={getVendorOptionsNonSpecial(valueForm.partnersPreQualifiedReason)} 
                          loading={vendorLoading} 
                          editable 
                          placeHolder='กรุณาระบุชื่อ Vendor ที่ต้องการจัดจ้างพิเศษ' 
                          type={type.select} 
                          component={FieldInput} 
                        />
                      </div>
                    </Collapse>
                  <div className='rowFields'>
                    <Field
                      name='isAdditional'
                      label='Additional PR'
                      type={type.switch}
                      specialOnChange={(value) => {
                        if (value === true) {
                          change('special', false)
                          change('specialReason', '')
                          change('subSpecialReason', '')
                          change('vendorCode', '')

                          if (props.poNumbers.companyCode !== valueForm.companyCode) {
                            props.getPoNumber(valueForm.companyCode, () => { change('referencePoNo', '') })
                          } else {
                            if (props.poNumbers.data.length === 0 && props.poNumbers.loading === false) {
                              props.getPoNumber(valueForm.companyCode, () => { change('referencePoNo', '') })
                            }
                          }
                        } else {
                          change('additionalReason', '')
                          change('referencePoNo', '')
                          change('referenceContractNo', '')
                        }
                      }}
                      component={FieldInput} />
                  </div>
                  <Collapse in={valueForm && valueForm.isAdditional} timeout={500}>
                    {AdditionalRemark()}
                    <div className='rowFields'>
                      <Field
                        require
                        name='additionalReason'
                        label='Additional Detail'
                        placeHolder='ระบุรายละเอียดเพิ่มเติมของงานเพิ่ม'
                        type={type.textArea}
                        component={FieldInput} />
                    </div>
                    <div className='rowFields'>
                      <Field
                        require
                        name='referencePoNo'
                        label='Reference SAP PO (Original) No'
                        placeHolder=''
                        options={props.poNumbers.data}
                        loading={props.poNumbers.loading}
                        type={type.select}
                        specialOnChange={(value) => {
                          var po = props.poNumbers.data.find(x => x.value === value)
                          if (po !== null) {
                            change('referencePoId', po.poId)
                          }
                        }}
                        component={FieldInput} />
                      <Field
                        name='referenceContractNo'
                        label='Reference Contract No'
                        type={type.text}
                        component={FieldInput}
                      />
                    </div>
                    {
                        valueForm.isAdditional && valueForm.referencePoId ?
                          <div className='rowFields'>
                            <a 
                              href={purchaseOrderDetailPath(valueForm.referencePoId)} 
                              target='_blank'
                              style={{
                                color: v.ezMainColor,
                                fontWeight: 'bold',
                                textDecoration: 'underline'
                              }}
                            >PO Detail</a>
                          </div> : null
                      }
                  </Collapse>
                  {
                    subCategory.isRent || (valueForm && valueForm.rentDays) ?
                      <div className='rowFields'>
                        <Field
                          require
                          name='rentDays'
                          label='Rent (days)'
                          className='halfRow'
                          type={type.text}
                          component={FieldInput} />
                      </div> : null
                  }
                </GeneralInfoContainer>
              </CardContent>
            </Collapse>
          </Card>
        </BudgetDetailContainer>
        <Modal open={modal.show}>
          <Modal.Header>{modal.header}</Modal.Header>
          <Modal.Content>{modal.message}</Modal.Content>
          <Modal.Actions>
            <Button
              icon='delete'
              color='red'
              labelPosition='left'
              content='Close'
              onClick={() => showModal(false, '', '')} />
          </Modal.Actions>
        </Modal>
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = (state) => {
  const valueForm = getFormValues('formEditPR')(state) || {}
  var subCategory = state.pr.subCategory

  const user = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  if (!valueForm.requesterUser && user) {
    valueForm.requesterUser = lower(user)
  }

  const members = state.member.members
  if ((valueForm.requesterUser && !(valueForm.companyCode)) && members.length > 0) {
    var member = members.find(m => lower(m.username) === valueForm.requesterUser)
    if (member) {
      valueForm.companyCode = member.companyCode || ''
      valueForm.requesterDepartment = member.mainDepartmentEn || ''
      valueForm.costCenterByRequester = member.costCenterCode || ''
    }
  }

  var goaOptions = []
  var defaultGoa = 0
  if (valueForm.companyCode && state.goa.goa && state.goa.goa[valueForm.companyCode]) {
    goaOptions = state.goa.goa[valueForm.companyCode].map(goa => {
      if (goa.defaultWithCompany) { defaultGoa = goa.id }
      return { value: goa.id, text: goa.name }
    })

    if (defaultGoa === 0 && goaOptions.length === 1) {
      defaultGoa = goaOptions[0].value
    }

    if (valueForm.goaId && (valueForm.goaId !== defaultGoa)) {
      valueForm.goaId = defaultGoa
    } else if (valueForm.goaId === 0) {
      valueForm.goaId = defaultGoa
    }
  }

  var projectOptions = []
  if (valueForm.companyCode && state.goa.projects && state.goa.projects[valueForm.companyCode]) {
    projectOptions = state.goa.projects[valueForm.companyCode].map(p => {
      return { value: `${p.id}`, text: p.projectName }
    })

    if (state.goa.projects.other) {
      state.goa.projects.other.forEach(p => {
        projectOptions.push({ value: `${p.id}`, text: p.projectName })
      })
    }
  }

  var specialApprovalOptions = []
  if (valueForm.projectId && state.goa.specialApprovals && state.goa.specialApprovals[valueForm.projectId]) {
    specialApprovalOptions = state.goa.specialApprovals[valueForm.projectId].map(s => {
      return { value: s.id, text: s.name }
    })
  }

  return ({
    valueForm,
    subCategory,
    menus: state.pr.menus,
    companyOptions: state.options.companies.data,
    vendorLoading: state.options.vendors.loading,
    vendorOptions: state.options.vendors.data,
    prCategoryOptions: state.options.prCategories.data,
    memberLoading: state.member.memberLoading,
    members: state.member.members,
    projectOptions,
    specialApprovalOptions,
    defaultGoa,
    glAccounts: state.pr.glAccounts,
    glLoading: state.pr.glLoading,
    goa: state.goa.goa,
    goaCompanyLoading: state.goa.goaCompanyLoading,
    goaLoading: state.goa.goaLoading,
    goaItems: state.goa.goaItems,
    goaItemByGoaIdLoading: state.goa.goaItemByGoaIdLoading,
    goaItemLoading: state.goa.goaItemLoading,
    projects: state.goa.projects,
    projectCompanyLoading: state.goa.projectCompanyLoading,
    projectLoading: state.goa.projectLoading,
    specialApprovals: state.goa.specialApprovals,
    specialApprovalProjectIdLoading: state.goa.specialApprovalProjectIdLoading,
    specialApprovalLoading: state.goa.specialApprovalLoading,
    purchasingGroupLoading: state.options.purchasingGroups.loading,
    purchasingGroupOptions: state.options.purchasingGroups.data,
    mappingPurchasingGroups: state.mappingData.purchasingGroups.data,
    companyPlants: state.mappingData.companyPlants.data,
    companyPlantLoading: state.mappingData.companyPlants.loading,
    plantStorageLocations: state.mappingData.plantStorageLocations.data,
    plantStorageLocationLoading: state.mappingData.plantStorageLocations.loading,
    prSpecial: state.options.prSpecial,
    poNumbers: state.options.poNumbers,
  })
}

const mapDispatchToProps = {
  getVendors,
  getHrmsMembers,
  addOtherMember,
  getGoaByCompany,
  getGoaItem,
  getGlAccount,
  getProjectByCompany,
  addOtherProject,
  getSpecialApproval,
  showModal,
  getMappingCompanyPlants,
  getMappingPlantStorageLocations,
  showConfirmModal,
  getPrSpecialOptions,
  getPoNumber,
  getAllMembers
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralDetail)
